import { Util } from "../../../util/util";
export class BeforeTaxDistributor {
    allocator;
    constructor(allocator) {
        this.allocator = allocator;
    }
    distribute({ cart, discountItems, totalDiscountedItemsPrice, computedDiscountToAllocate, configuredDiscountValue }) {
        const cartItemByKey = new Map(cart.items.map((i) => [i.itemKey, i]));
        // Work lists for redistribution rounds
        let remainingItems = discountItems;
        let remainingTotalPrice = totalDiscountedItemsPrice;
        let remainingDiscount = computedDiscountToAllocate;
        while (remainingDiscount > 0 && remainingItems.length > 0 && remainingTotalPrice > 0) {
            const round = this._processBeforeTaxRound(remainingItems, cartItemByKey, remainingDiscount, remainingTotalPrice, configuredDiscountValue);
            // Don't redistribute any other discount amounts when max discount has been reached for items
            if (round.appliedThisRound === round.processedItemsAmount)
                return;
            // Clear rounding discrepancy on the last eligible item
            this._applyRoundingAdjustment(remainingItems, round.roundingIndex, round.remainingDiscountForThisRound, round.appliedThisRound);
            // Stop if nothing to redistribute
            if (round.redistribute <= 0)
                return;
            // Next round: only items not maxed out
            remainingItems = round.nextItems;
            remainingTotalPrice = round.remainingTotalPrice;
            remainingDiscount = round.redistribute;
        }
    }
    _processBeforeTaxRound(items, cartItemByKey, remainingDiscount, remainingTotalPrice, configuredDiscountValue) {
        const nextItems = [];
        let appliedThisRound = 0;
        let redistribute = 0;
        let roundingIndex = -1;
        let processedItemsAmount = 0;
        for (let i = 0; i < items.length; i++) {
            const dItem = items[i];
            const oItem = cartItemByKey.get(dItem.itemKey);
            if (!oItem)
                continue;
            processedItemsAmount += dItem.oPrice;
            const result = this.allocator.allocate({
                dItem,
                oItem,
                remainingDiscount: remainingDiscount,
                remainingTotalPrice: remainingTotalPrice,
                configuredDiscountValue,
            });
            appliedThisRound += result.allocated;
            redistribute += result.wantsRedistribute;
            if (result.eligibleForRounding) {
                roundingIndex = i;
                nextItems.push(dItem);
            }
            if (result.itemPriceRemoved) {
                remainingTotalPrice -= result.itemPriceRemoved;
                remainingDiscount -= result.wantsRedistribute;
            }
        }
        return {
            nextItems,
            remainingDiscountForThisRound: remainingDiscount,
            remainingTotalPrice,
            appliedThisRound,
            redistribute,
            roundingIndex,
            processedItemsAmount
        };
    }
    _applyRoundingAdjustment(items, roundingIndex, remainingDiscountForThisRound, appliedThisRound) {
        if (roundingIndex < 0)
            return;
        const item = items[roundingIndex];
        if (!item)
            return;
        item.beforeTaxDiscount += Util.Float2(remainingDiscountForThisRound - appliedThisRound);
    }
}
//# sourceMappingURL=before-tax-distributor.js.map